(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["au-cart-tagalys-recommendations"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var S = '[data-product-based-widget]';
    var WIDGET = '[data-pbw-loc="scrollable"]';
    var EMPTY  = '[data-pbw-loc="empty"]';
    var DRAWER = '#CartDrawer';

    var $drawer, $products;
    var sId = 0, cId = 0;
    var lock = false, pending = false, ready = false, debounce = null;
    var enhancing = false, enhanceQueued = false, enhanceGen = 0;

    function $$(sel, root) { return (root || document).querySelectorAll(sel); }
    function isVisible() {
      return $drawer && ($drawer.classList.contains('drawer--is-open') || $drawer.classList.contains('is-visible'));
    }

    function resetContainer(loc) {
      var el = document.querySelector(loc === 'empty' ? EMPTY : WIDGET);
      if (el) {
        delete el.__auInited;
        el.__auCarouselIndex = 0;
        el.innerHTML = '';
      }
      return el;
    }

    /* ── Product JSON cache ── */
    var productCache = {};
    function fetchProduct(handle, cb) {
      if (productCache[handle]) { cb(productCache[handle]); return; }
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) { productCache[handle] = p; cb(p); })
        .catch(function () { cb(null); });
    }

    /* ── Helper to resolve option name string from either string or object ── */
    function getOptionName(opt) {
      if (!opt) return '';
      if (typeof opt === 'string') return opt;
      if (typeof opt === 'object' && opt.name) return opt.name;
      return '';
    }

    /* ── Determine CTA label from option name ── */
    function ctaLabel(opt) {
      var optName = getOptionName(opt);
      var n = (optName || '').toLowerCase();
      if (n === 'color' || n === 'colour') return 'Choose Colour';
      if (n === 'size') return 'Choose Size';
      if (n.indexOf('flavo') > -1 || n.indexOf('flavou') > -1 || n.indexOf('flavor') > -1) return 'Choose Flavour';
      return 'Choose Option';
    }



    /* ── Build single variant dropdown populated with variant titles ── */
    function buildVariantUI(cardEl, product, handle, ctaBtn) {
      if (!product || !product.variants || product.variants.length <= 1) {
        return null;
      }

      /* Single variant or "Default Title" only → keep standard Add button */
      if (product.variants.length === 1 || (product.options.length === 1 && getOptionName(product.options[0]) === 'Title')) {
        return null;
      }

      var wrapper = document.createElement('div');
      wrapper.className = 'au-tagalys-variant-area au-tagalys-variant-area--hidden';
      wrapper.setAttribute('data-handle', handle);

      var sel = document.createElement('select');
      sel.className = 'au-tagalys-variant-select';

      var availableVariants = [];
      for (var vi = 0; vi < product.variants.length; vi++) {
        var v = product.variants[vi];
        var optionEl = document.createElement('option');
        optionEl.value = v.id;
        optionEl.textContent = v.title + (v.available ? '' : ' (Sold Out)');
        if (!v.available) {
          optionEl.disabled = true;
        } else {
          availableVariants.push(v);
        }
        sel.appendChild(optionEl);
      }

      if (availableVariants.length > 0) {
        sel.value = availableVariants[0].id;
      }

      wrapper.appendChild(sel);

      /* Add to cart button (visible immediately after clicking CTA) */
      var addBtn = document.createElement('button');
      addBtn.className = 'au-tagalys-add-to-cart';
      addBtn.textContent = availableVariants.length > 0 ? 'Add' : 'Sold Out';
      addBtn.setAttribute('data-handle', handle);
      addBtn.setAttribute('type', 'button');
      if (availableVariants.length === 0) {
        addBtn.disabled = true;
        addBtn.classList.add('au-tagalys-atc--sold-out');
      }
      addBtn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (addBtn.disabled || addBtn.classList.contains('au-tagalys-atc--sold-out')) return;
        var selectedVid = sel.value || (availableVariants.length > 0 ? availableVariants[0].id : product.variants[0].id);
        addToCart(handle, addBtn, selectedVid);
      });
      wrapper.appendChild(addBtn);

      /* When select changes, update card image and button state */
      sel.addEventListener('change', function (e) {
        if (e) { e.stopPropagation(); }
        var selectedVid = sel.value;
        var selectedVariant = null;
        for (var i = 0; i < product.variants.length; i++) {
          if (String(product.variants[i].id) === String(selectedVid)) {
            selectedVariant = product.variants[i];
            break;
          }
        }
        if (selectedVariant) {
          if (!selectedVariant.available) {
            addBtn.disabled = true;
            addBtn.textContent = 'Sold Out';
            addBtn.classList.add('au-tagalys-atc--sold-out');
          } else {
            addBtn.disabled = false;
            addBtn.textContent = 'Add';
            addBtn.classList.remove('au-tagalys-atc--sold-out');
          }
          var newSrc = (selectedVariant.featured_image && selectedVariant.featured_image.src)
                       ? selectedVariant.featured_image.src
                       : (product.featured_image ? product.featured_image : null);
          if (newSrc) {
            var img = cardEl.querySelector('.product-image');
            if (img) {
              var currentSrc = img.getAttribute('data-src') || img.src || '';
              var ssMatch = currentSrc.match(/^(https:\/\/s(?:f|)cdn\.speedsize\.com\/[^/]+\/)/);
              if (ssMatch) {
                newSrc = newSrc.replace(/^https:\/\/s(?:f|)cdn\.speedsize\.com\/[^/]+\//, '');
                newSrc = ssMatch[1] + newSrc;
              }
              img.setAttribute('data-src', newSrc);
              img.src = newSrc;
            }
          }
        }
      });
      sel.addEventListener('click', function (e) { e.stopPropagation(); });

      /* Stop click and change events from bubbling out of the variant area */
      wrapper.addEventListener('click', function (e) { e.stopPropagation(); });
      wrapper.addEventListener('change', function (e) { e.stopPropagation(); });

      return wrapper;
    }

    /* ── Custom Carousel Engine ── */
    function getSliderState(btnOrContainer) {
      var widget = btnOrContainer.closest('.products-and-navigation')
                || btnOrContainer.closest(S)
                || btnOrContainer.closest('.tagalys-namespace')
                || btnOrContainer.closest('#CartDrawer');
      if (!widget) return null;

      var container = widget.querySelector('.products.display-carousel');
      if (!container) return null;

      var track = container.firstElementChild || container.children[0];
      if (!track) return null;

      var items = track.children;
      if (!items || !items.length) return null;

      var itemWidth = 0;
      for (var k = 0; k < items.length; k++) {
        var w = items[k].getBoundingClientRect().width;
        if (w > 0 && items[k].style.display !== 'none') {
          itemWidth = w;
          break;
        }
      }
      if (!itemWidth) itemWidth = items[0].getBoundingClientRect().width || 0;
      var gap = 16;
      var step = itemWidth + gap;
      var viewportWidth = container.getBoundingClientRect().width;
      var totalTrackWidth = 0;
      var visibleCount = 0;
      for (var ti = 0; ti < items.length; ti++) {
        if (items[ti].style.display === 'none') continue;
        var cardW = items[ti].getBoundingClientRect().width || itemWidth;
        totalTrackWidth += cardW;
        visibleCount++;
      }
      if (visibleCount > 1) {
        totalTrackWidth += (visibleCount - 1) * gap;
      }
      var maxOffset = Math.max(0, totalTrackWidth - viewportWidth);
      /* Round to avoid off-by-one at edges due to subpixel sizing */
      var maxIndex = step > 0 ? Math.max(0, Math.round(maxOffset / step)) : 0;

      return {
        widget: widget,
        container: container,
        track: track,
        items: items,
        itemWidth: itemWidth,
        gap: gap,
        step: step,
        viewportWidth: viewportWidth,
        maxOffset: maxOffset,
        maxIndex: maxIndex,
        totalTrackWidth: totalTrackWidth
      };
    }

    function getPrevNextBtns(widget) {
      /* Detect prev/next by the SVG chevron class inside the button */
      var prevBtn = null, nextBtn = null;
      var btns = widget.querySelectorAll('.carousel-btn');
      for (var i = 0; i < btns.length; i++) {
        if (btns[i].querySelector('.chevron-icon-prev')) prevBtn = btns[i];
        else if (btns[i].querySelector('.chevron-icon-next')) nextBtn = btns[i];
      }
      /* Fallback: first = prev, second = next */
      if (!prevBtn && btns.length > 0) prevBtn = btns[0];
      if (!nextBtn && btns.length > 1) nextBtn = btns[1];
      return { prev: prevBtn, next: nextBtn };
    }

    function slideTo(state, index, skipTransition) {
      if (!state) return 0;
      var clamped = Math.max(0, Math.min(index, state.maxIndex));
      var targetTranslate = clamped >= state.maxIndex
        ? state.maxOffset
        : Math.min(state.maxOffset, Math.max(0, clamped * state.step));

      /* Re-enable smooth transition for snap (unless explicitly skipped) */
      if (skipTransition) {
        state.track.style.setProperty('transition', 'none', 'important');
      } else {
        state.track.style.removeProperty('transition');
      }
      state.track.style.setProperty('transform', 'translate3d(-' + targetTranslate + 'px, 0px, 0px)', 'important');

      /* Toggle btn-disabled class on prev/next buttons */
      var btns = getPrevNextBtns(state.widget);
      if (btns.prev) {
        if (clamped <= 0) btns.prev.classList.add('btn-disabled');
        else btns.prev.classList.remove('btn-disabled');
      }
      if (btns.next) {
        /* Disable next if at max OR track fits entirely in viewport */
        if (clamped >= state.maxIndex || state.maxOffset < 1) btns.next.classList.add('btn-disabled');
        else btns.next.classList.remove('btn-disabled');
      }

      return clamped;
    }

    function resetCarousel(widget, instant) {
      if (!widget) return;
      widget.__auCarouselIndex = 0;
      var state = getSliderState(widget);
      if (state) {
        slideTo(state, 0, instant !== false);
      }
    }

    function resetAllCarousels(instant) {
      var widgets = $$(S);
      for (var w = 0; w < widgets.length; w++) {
        resetCarousel(widgets[w], instant);
      }
    }

    /* Single global capture listener on document for all carousel buttons */
    function initCarouselButtons() {
      if (document.__auCarouselButtonsInited) return;
      document.__auCarouselButtonsInited = true;

      document.addEventListener('click', function (e) {
        var btn = e.target.closest('.carousel-btn');
        if (!btn) return;

        var widget = btn.closest(S);
        if (!widget) return;

        /* ALWAYS stop Tagalys or any external click handlers from interfering */
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (btn.classList.contains('btn-disabled')) return;

        var state = getSliderState(widget);
        if (!state) return;

        var btns = getPrevNextBtns(widget);
        var isPrev = (btn === btns.prev) || !!btn.querySelector('.chevron-icon-prev');
        var curIdx = typeof widget.__auCarouselIndex === 'number' ? widget.__auCarouselIndex : 0;

        var targetIdx = isPrev ? curIdx - 1 : curIdx + 1;
        widget.__auCarouselIndex = slideTo(state, targetIdx);
      }, true);
    }

    function initCustomCarouselEngine() {
      initCarouselButtons();

      var widgets = $$(S);
      for (var w = 0; w < widgets.length; w++) {
        var root = widgets[w];

        var state = getSliderState(root);
        if (!state) continue;

        /* Skip if cards haven't rendered yet (0 width) */
        if (state.itemWidth < 1) continue;

        /* If drawer is closed, always reset to slide 0 */
        if (!isVisible()) {
          root.__auCarouselIndex = 0;
        }

        var idx = typeof root.__auCarouselIndex === 'number' ? root.__auCarouselIndex : 0;
        idx = Math.max(0, Math.min(idx, state.maxIndex));
        root.__auCarouselIndex = slideTo(state, idx, !isVisible());
      }
    }

    function enhance() {
      /* Re-entrancy guard: if enhance is already running (e.g. triggered by
         MutationObserver reacting to our own DOM changes), defer to after */
      if (enhancing) { enhanceQueued = true; return; }
      enhancing = true;
      enhanceGen++;
      var gen = enhanceGen;

      var widgets = $$(S);
      for (var w = 0; w < widgets.length; w++) {
        var root = widgets[w];
        var imgs = $$('.product-image[data-src]', root);
        for (var i = 0; i < imgs.length; i++) {
          var img = imgs[i];
          if (!img.src) img.src = img.getAttribute('data-src');
        }
        var prods = $$('.product', root);
        for (var p = 0; p < prods.length; p++) {
          var el = prods[p];
          /* Skip if card already has our custom elements */
          if (el.querySelector('.au-tagalys-add-to-cart') || el.querySelector('.au-tagalys-choose-btn') || el.querySelector('.au-tagalys-variant-area')) continue;
          var link = el.querySelector('.product-link');
          if (!link) continue;
          var href = link.getAttribute('href');
          if (!href) continue;
          var m = href.match(/\/products\/([^?#]+)/);
          if (!m) continue;
          var handle = m[1];

          var btn = document.createElement('button');
          btn.className = 'au-tagalys-add-to-cart';
          btn.textContent = 'Add';
          btn.setAttribute('data-handle', handle);
          btn.setAttribute('type', 'button');

          var cachedProd = productCache[handle];
          if (cachedProd) {
            var cachedAvail = (cachedProd.available !== false);
            if (cachedAvail && cachedProd.variants && cachedProd.variants.length > 0) {
              cachedAvail = cachedProd.variants.some(function (v) { return v.available; });
            }
            if (!cachedAvail) {
              btn.disabled = true;
              btn.textContent = 'Sold Out';
              btn.classList.add('au-tagalys-atc--sold-out');
            }
          }

          btn.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            if (this.disabled || this.classList.contains('au-tagalys-atc--sold-out')) return;
            addToCart(this.getAttribute('data-handle'), this);
          });
          el.appendChild(btn);

          /* Step 2: Async upgrade — if product has variants, swap Add for "Choose X" CTA */
          (function (cardEl, addBtn, prodHandle, cardGen) {
            fetchProduct(prodHandle, function (product) {
              /* Guard: stale callback from a previous generation — card may have been re-rendered */
              if (enhanceGen !== cardGen && !cardEl.parentNode) return;
              /* Guard: variant area or CTA already exists on this card */
              if (cardEl.querySelector('.au-tagalys-variant-area') || cardEl.querySelector('.au-tagalys-choose-btn')) return;
              /* Guard: the Add button we created has been removed (card was replaced by Tagalys) */
              if (!addBtn.parentNode) return;
              if (!product || !product.variants || !product.variants.length) return;

              /* ── Availability check: update sold-out CTA label ── */
              var isAvailable = (product.available !== false);
              if (isAvailable && product.variants && product.variants.length > 0) {
                var anyAvailable = product.variants.some(function (v) { return v.available; });
                if (!anyAvailable) isAvailable = false;
              }

              if (!isAvailable) {
                if (addBtn && addBtn.parentNode) {
                  addBtn.disabled = true;
                  addBtn.textContent = 'Sold Out';
                  addBtn.classList.remove('au-tagalys-atc--busy', 'au-tagalys-atc--added');
                  addBtn.classList.add('au-tagalys-atc--sold-out');
                }
                return;
              }

              /* ── Special PDP-redirect products ─────────────────────────── */
              var pdpLabel = null;
              var productTags = (product.tags || []).map(function (t) { return t.toLowerCase(); });

              if (product.product_type === 'Personalised') {
                pdpLabel = 'Personalize';
              } else if (productTags.indexOf('biscuits-bundle') > -1) {
                pdpLabel = 'Build Bundle';
              }

              if (pdpLabel) {
                var pdpBtn = document.createElement('button');
                pdpBtn.className = 'au-tagalys-choose-btn';
                pdpBtn.textContent = pdpLabel;
                pdpBtn.setAttribute('type', 'button');
                pdpBtn.addEventListener('click', function (e) {
                  e.preventDefault(); e.stopPropagation();
                  window.location.href = '/products/' + prodHandle;
                });
                if (addBtn.parentNode) {
                  addBtn.parentNode.replaceChild(pdpBtn, addBtn);
                }
                return;
              }
              /* ── End special PDP-redirect products ─────────────────────── */

              /* Single variant or only default "Title" option → keep the Add button */
              if (product.variants.length <= 1) return;
              var firstOptName = getOptionName(product.options[0]);
              if (product.options.length === 1 && firstOptName === 'Title') return;

              /* Multi-variant → replace Add button with CTA */
              var ctaText = ctaLabel(product.options[0]);
              var ctaBtn = document.createElement('button');
              ctaBtn.className = 'au-tagalys-choose-btn';
              ctaBtn.textContent = ctaText;
              ctaBtn.setAttribute('type', 'button');

              /* Build variant UI */
              var variantUI = buildVariantUI(cardEl, product, prodHandle, ctaBtn);
              if (!variantUI) return;

              ctaBtn.addEventListener('click', function (e) {
                e.preventDefault(); e.stopPropagation();
                ctaBtn.style.display = 'none';
                variantUI.classList.remove('au-tagalys-variant-area--hidden');
              });

              /* Swap: remove old Add button, insert variantUI and CTA */
              if (addBtn.parentNode) {
                addBtn.parentNode.insertBefore(variantUI, addBtn);
                addBtn.parentNode.replaceChild(ctaBtn, addBtn);
              }
            });
          })(el, btn, handle, gen);
        }
        var btns = $$('button:not([type]), button[type="submit"]', root);
        for (var b = 0; b < btns.length; b++) {
          if (!btns[b].classList.contains('au-tagalys-add-to-cart') && !btns[b].classList.contains('au-tagalys-choose-btn'))
            btns[b].setAttribute('type', 'button');
        }

        /* Block clicks on non-link areas (under button, prices, whitespace) from navigating to PDP */
        if (!root.__auLinkGuard) {
          root.__auLinkGuard = true;
          root.addEventListener('click', function (e) {
            /* Interactive controls (Add to cart, choose option, variant dropdowns) */
            if (e.target.closest('button, select, input, option, textarea, .au-tagalys-add-to-cart, .au-tagalys-choose-btn, .au-tagalys-variant-area, .carousel-btn')) {
              return;
            }
            /* Product image or title: allow PDP navigation */
            if (e.target.closest('.product-image-container, .product-image, img, .product-name, .product-title')) {
              return;
            }
            /* Any other area inside the card (under button, margins, prices): BLOCK PDP navigation */
            var card = e.target.closest('.product, .products.display-carousel > div > div');
            if (card) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
            }
          }, true);
        }
      }

      /* Run custom carousel engine after DOM enhancement */
      initCustomCarouselEngine();

      enhancing = false;
      if (enhanceQueued) {
        enhanceQueued = false;
        setTimeout(enhance, 60);
      }
    }

    function stagger(id, delays) {
      for (var i = 0; i < delays.length; i++) {
        (function (d) {
          setTimeout(function () { if (id === sId) enhance(); }, d);
        })(delays[i]);
      }
    }

    function refresh() {
      if (!isVisible()) return;
      if (lock) { pending = true; return; }
      lock = true;
      try {
        if (typeof TagalysCustomisations !== 'undefined' &&
            typeof TagalysCustomisations.initProductBasedWidget === 'function') {
          try { if (TagalysCustomisations.initProductBasedWidget()) ready = true; }
          catch (e) { console.warn('[au-tagalys] init error:', e); }
        }
        if (ready) { sId++; stagger(sId, [0, 150, 400, 800, 1500, 3000]); }
      } catch (e) { console.warn('[au-tagalys] refresh error:', e); }
      finally {
        lock = false;
        if (pending) { pending = false; setTimeout(refresh, 50); }
      }
    }

    function debouncedRefresh() {
      clearTimeout(debounce);
      debounce = setTimeout(refresh, 250);
    }

    function forceRefreshFromOpen() {
      resetAllCarousels(true);
      var loc = $drawer && $drawer.classList.contains('is-empty') ? 'empty' : 'scrollable';
      var container = document.querySelector(loc === 'empty' ? EMPTY : WIDGET);
      var hasCards = container && container.querySelectorAll('.product').length > 0;

      if (!hasCards) {
        resetContainer(loc);
      }
      watchParents();
      refresh();
      setTimeout(initViewport, 50);
      stagger(sId, [200, 500, 1000, 2000, 3500, 5000]);
    }

    var watchDebounce = null;
    function watchParents() {
      var parents = $$('#CartDrawer .drawer__scrollable, #CartDrawer .drawer__cart-empty');
      for (var i = 0; i < parents.length; i++) {
        var p = parents[i];
        if (p.__auMon) continue;
        p.__auMon = true;
        new MutationObserver(function () {
          /* Debounce observer-triggered enhance to prevent loops from our own DOM changes */
          clearTimeout(watchDebounce);
          watchDebounce = setTimeout(enhance, 80);
        }).observe(p, { childList: true, subtree: true });
      }
    }

    var io = null;
    function initViewport() {
      if (typeof IntersectionObserver === 'undefined') return;
      if (!io) {
        io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              refresh();
              setTimeout(enhance, 300);
              setTimeout(enhance, 800);
              setTimeout(enhance, 1500);
            }
          }
        }, { root: document.querySelector(DRAWER + ' .drawer__scrollable'), threshold: 0.01 });
      }
      var ws = $$(S);
      for (var w = 0; w < ws.length; w++) {
        if (!ws[w].__auViewportObserved) { ws[w].__auViewportObserved = true; io.observe(ws[w]); }
      }
    }

    function initDragGuard() {
      if (document.__auDG) return;
      document.__auDG = true;

      var startX = 0, startY = 0, currentX = 0;
      var isDragging = false, dragged = false;
      var dragStartIndex = 0;
      var activeDragWidget = null;
      var activeDragState = null;
      var directionLocked = false, isHorizontalDrag = false;

      function inWidget(t) { return t && t.closest && t.closest(S); }

      function isInteractive(t) {
        var tag = t.tagName;
        if (tag === 'SELECT' || tag === 'INPUT' || tag === 'BUTTON' || tag === 'TEXTAREA' || tag === 'OPTION') return true;
        if (t.closest && t.closest('select, input, button, textarea, .au-tagalys-variant-area, .carousel-actions-container, .carousel-btn')) return true;
        return false;
      }

      function snapBackCurrent() {
        if (activeDragWidget) {
          var st = activeDragState || getSliderState(activeDragWidget);
          if (st) {
            st.track.style.removeProperty('transition');
            slideTo(st, activeDragWidget.__auCarouselIndex || 0);
          }
        }
      }

      function reset() {
        isDragging = false;
        activeDragWidget = null;
        activeDragState = null;
        startX = 0;
        startY = 0;
        currentX = 0;
        directionLocked = false;
        isHorizontalDrag = false;
        setTimeout(function () { dragged = false; }, 80);
      }

      function liveDrag(clientX) {
        if (!activeDragWidget || !activeDragState || !dragged) return;
        var st = activeDragState;

        var dragOffset = clientX - startX;
        var baseTranslate = dragStartIndex >= st.maxIndex
          ? st.maxOffset
          : Math.min(st.maxOffset, Math.max(0, dragStartIndex * st.step));
        var rawTranslate = baseTranslate - dragOffset;

        /* Rubber-band overscroll at boundaries */
        var newTranslate;
        if (rawTranslate < 0) {
          newTranslate = rawTranslate * 0.25;
        } else if (rawTranslate > st.maxOffset) {
          newTranslate = st.maxOffset + (rawTranslate - st.maxOffset) * 0.25;
        } else {
          newTranslate = rawTranslate;
        }

        /* Disable CSS transition during drag for 1:1 responsive feel */
        st.track.style.setProperty('transition', 'none', 'important');
        st.track.style.setProperty('transform', 'translate3d(' + (-newTranslate) + 'px, 0px, 0px)', 'important');
      }

      /* PREVENT NATIVE BROWSER HTML5 DRAG ON IMAGES & LINKS */
      document.addEventListener('dragstart', function (e) {
        if (inWidget(e.target)) {
          e.preventDefault();
        }
      }, true);

      /* MOUSE DOWN */
      document.addEventListener('mousedown', function (e) {
        if (isInteractive(e.target)) return;
        var widget = inWidget(e.target);
        if (widget) {
          var st = getSliderState(widget);
          if (!st || st.itemWidth < 1) return;
          isDragging = true;
          dragged = false;
          directionLocked = true;
          isHorizontalDrag = true;
          startX = e.clientX;
          startY = e.clientY;
          currentX = e.clientX;
          activeDragWidget = widget;
          activeDragState = st;
          dragStartIndex = typeof widget.__auCarouselIndex === 'number' ? widget.__auCarouselIndex : 0;
          e.preventDefault();
        }
      }, true);

      /* MOUSE MOVE */
      document.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        if (e.buttons === 0) {
          snapBackCurrent();
          reset();
          return;
        }
        currentX = e.clientX;
        var dx = Math.abs(e.clientX - startX);
        if (dx > 5) {
          dragged = true;
          liveDrag(e.clientX);
        }
      }, true);

      /* TOUCH START */
      document.addEventListener('touchstart', function (e) {
        if (isInteractive(e.target)) return;
        var t = e.touches[0];
        if (!t) return;
        var widget = inWidget(e.target);
        if (widget) {
          var st = getSliderState(widget);
          if (!st || st.itemWidth < 1) return;
          isDragging = true;
          dragged = false;
          directionLocked = false;
          isHorizontalDrag = false;
          startX = t.clientX;
          startY = t.clientY;
          currentX = t.clientX;
          activeDragWidget = widget;
          activeDragState = st;
          dragStartIndex = typeof widget.__auCarouselIndex === 'number' ? widget.__auCarouselIndex : 0;
        }
      }, { capture: true, passive: true });

      /* TOUCH MOVE */
      document.addEventListener('touchmove', function (e) {
        if (!isDragging || !activeDragWidget) return;
        var t = e.touches[0];
        if (!t) return;
        currentX = t.clientX;
        var dx = Math.abs(t.clientX - startX);
        var dy = Math.abs(t.clientY - startY);

        if (!directionLocked && (dx > 6 || dy > 6)) {
          directionLocked = true;
          isHorizontalDrag = dx > dy;
        }

        if (directionLocked && isHorizontalDrag) {
          if (e.cancelable) e.preventDefault();
          if (dx > 4) {
            dragged = true;
            liveDrag(t.clientX);
          }
        }
      }, { capture: true, passive: false });

      /* RELEASE (MOUSEUP & TOUCHEND) */
      function handleRelease(e) {
        if (isDragging && activeDragWidget) {
          var widget = activeDragWidget;
          var st = activeDragState || getSliderState(widget);

          if (e) {
            if (e.changedTouches && e.changedTouches[0]) currentX = e.changedTouches[0].clientX;
            else if (typeof e.clientX === 'number' && e.clientX > 0) currentX = e.clientX;
          }

          if (dragged && st) {
            var dragDist = currentX - startX;
            var stepsMoved = Math.round(-dragDist / st.step);
            if (stepsMoved === 0) {
              var threshold = st.step * 0.18;
              if (dragDist < -threshold) stepsMoved = 1;
              else if (dragDist > threshold) stepsMoved = -1;
            }
            var targetIdx = Math.max(0, Math.min(st.maxIndex, dragStartIndex + stepsMoved));
            st.track.style.removeProperty('transition');
            widget.__auCarouselIndex = slideTo(st, targetIdx);
          } else if (st) {
            snapBackCurrent();
          }
        }
        reset();
      }

      window.addEventListener('mouseup', handleRelease, true);
      window.addEventListener('touchend', handleRelease, true);
      window.addEventListener('blur', function () {
        if (isDragging) {
          snapBackCurrent();
          reset();
        }
      }, true);

      /* CLICK INTERCEPTION AFTER DRAG */
      document.addEventListener('click', function (e) {
        if (dragged) {
          if (e.target.closest('.carousel-btn')) {
            dragged = false;
            return;
          }
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          dragged = false;
        }
      }, true);

      /* PREVENT CLICKS UNDER / AFTER BUTTON / OUTSIDE TITLE & IMAGE FROM NAVIGATING TO PDP */
      document.addEventListener('click', function (e) {
        var widget = e.target.closest(S);
        if (!widget) return;

        /* Allow interactive controls (buttons, select dropdowns, inputs) */
        if (e.target.closest('button, select, input, option, textarea, .au-tagalys-add-to-cart, .au-tagalys-choose-btn, .au-tagalys-variant-area, .carousel-btn')) {
          return;
        }

        /* Allow image and title to navigate to PDP */
        if (e.target.closest('.product-image-container, .product-image, img, .product-name, .product-title, .grid-product__title, .grid-product__image')) {
          return;
        }

        /* Block ALL other clicks inside product cards (under/after button, prices, margins, whitespace) */
        var card = e.target.closest('.product, .products.display-carousel > div > div, .grid-product, .au-rec__card');
        if (card) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      }, true);

      /* WINDOW RESIZE: keep carousel aligned if viewport width changes */
      var resizeTimer = null;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initCustomCarouselEngine, 100);
      }, { passive: true });
    }

    var vCache = {};
    function addToCart(handle, btn, explicitVid) {
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding...';
        btn.classList.add('au-tagalys-atc--busy');
        btn.classList.remove('au-tagalys-atc--added');
      }
      var revert = function () {
        if (!btn) return;
        btn.textContent = 'Add';
        btn.classList.remove('au-tagalys-atc--busy', 'au-tagalys-atc--added');
      };
      var markSoldOut = function () {
        if (!btn) return;
        btn.disabled = true;
        btn.textContent = 'Sold Out';
        btn.classList.remove('au-tagalys-atc--busy', 'au-tagalys-atc--added');
        btn.classList.add('au-tagalys-atc--sold-out');
      };
      var go = function (vid) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1 })
        }).then(function (r) {
          if (r.ok) {
            if (btn) {
              btn.disabled = false;
              btn.textContent = 'Added';
              btn.classList.remove('au-tagalys-atc--busy');
              btn.classList.add('au-tagalys-atc--added');
              setTimeout(revert, 2000);
            }
            var scrollable = document.querySelector('#CartDrawer .drawer__scrollable');
            if (scrollable) {
              if (typeof scrollable.scrollTo === 'function') {
                scrollable.scrollTo({ top: 0, behavior: 'smooth' });
              } else {
                scrollable.scrollTop = 0;
              }
            } else {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { addToCartBtn: btn } }));
          } else {
            console.warn('[au-tagalys] add failed', r.status);
            if (r.status === 422) {
              markSoldOut();
            } else {
              if (btn) btn.disabled = false;
              revert();
            }
          }
        }).catch(function () { if (btn) btn.disabled = false; revert(); });
      };

      /* If an explicit variant ID was provided (from dropdown), use it directly */
      if (explicitVid) { go(explicitVid); return; }

      /* Fallback: fetch first available variant */
      if (vCache[handle]) { go(vCache[handle]); return; }
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          if (!p || p.available === false) {
            markSoldOut();
            return;
          }
          var firstAvailable = null;
          if (p.variants && p.variants.length) {
            for (var i = 0; i < p.variants.length; i++) {
              if (p.variants[i].available) {
                firstAvailable = p.variants[i].id;
                break;
              }
            }
          }
          if (firstAvailable) {
            vCache[handle] = firstAvailable;
            go(firstAvailable);
          } else {
            markSoldOut();
          }
        })
        .catch(function () { if (btn) btn.disabled = false; revert(); });
    }

    if (window.__auTagalysBooted) return;
    window.__auTagalysBooted = true;

    $drawer    = document.querySelector(DRAWER);
    $products  = $drawer && document.querySelector(DRAWER + ' [data-products]');

    watchParents();
    initDragGuard();
    initCarouselButtons();

    if (typeof onTagalysReady === 'function') {
      onTagalysReady(function () { ready = true; refresh(); });
    }

    if ($products) {
      new MutationObserver(debouncedRefresh).observe($products, { childList: true });
    }

    if ($drawer) {
      var lastOpen = isVisible();
      var lastEmpty = $drawer.classList.contains('is-empty');
      new MutationObserver(function () {
        var open = isVisible();
        if (lastOpen && !open) {
          /* Drawer was closed — reset all carousels to 1st slide */
          resetAllCarousels(true);
        }
        lastOpen = open;

        var isEmpty = $drawer.classList.contains('is-empty');
        if (isEmpty === lastEmpty) return;
        lastEmpty = isEmpty;

        resetContainer(isEmpty ? 'empty' : 'scrollable');

        cId++;
        var id = cId;
        var delays = [80, 400, 800, 1500, 2500];
        for (var i = 0; i < delays.length; i++) {
          (function (d) {
            setTimeout(function () { if (id === cId) refresh(); }, d);
          })(delays[i]);
        }
      }).observe($drawer, { attributes: true, attributeFilter: ['class'] });
    }

    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.js-drawer-close')) {
        resetAllCarousels(true);
      }
    }, true);

    document.addEventListener('drawerOpen.CartDrawer', forceRefreshFromOpen);
    document.addEventListener('drawerOpen', forceRefreshFromOpen);
    document.addEventListener('cart:updated', debouncedRefresh);
    document.addEventListener('ajaxProduct:added', debouncedRefresh);
    document.addEventListener('cart:refresh', debouncedRefresh);

    if (!window.__auTagalysPD) {
      window.__auTagalysPD = true;
      var tries = 0;
      var poll = setInterval(function () {
        if (typeof TagalysCustomisations !== 'undefined' &&
            typeof TagalysCustomisations.initProductBasedWidget === 'function') {
          try { refresh(); } catch (_) {}
          tries++;
        }
        if (tries > 50 || (ready && tries > 3)) clearInterval(poll);
      }, 500);
      setTimeout(function () { clearInterval(poll); }, 25000);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
